// src/components/AdminSettings/tabs/AppearanceTab.tsx
import React from 'react';
import { Card } from '../../ui/Card';
import { useTheme } from '../../../hooks/useTheme';
import { THEME_OPTIONS } from '../constants';
import type { AppearanceTabProps } from '../types';

export const AppearanceTab: React.FC<AppearanceTabProps> = () => {
  const { themeMode, setThemeMode, resolvedTheme } = useTheme();

  return (
    <Card title="App Theme">
      <p style={{
        color: 'var(--ion-color-medium)',
        fontFamily: 'var(--kff-data-font)',
        marginBottom: 16,
        fontSize: 14,
      }}>
        Choose how the companion app appears on your device.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {THEME_OPTIONS.map((option) => {
          const isSelected = themeMode === option.mode;
          return (
            <button
              key={option.mode}
              onClick={() => setThemeMode(option.mode)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                padding: 16,
                background: isSelected
                  ? 'rgba(var(--kff-forge-gold-rgb), 0.15)'
                  : 'var(--ion-color-step-50)',
                border: isSelected
                  ? '2px solid var(--kff-forge-gold)'
                  : '2px solid transparent',
                borderRadius: 12,
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'all 0.2s ease',
              }}
            >
              <span style={{ fontSize: 28 }}>{option.icon}</span>
              <div style={{ flex: 1 }}>
                <div style={{
                  fontFamily: 'var(--kff-heading-font)',
                  fontSize: 16,
                  fontWeight: 600,
                  color: 'var(--ion-text-color)',
                  marginBottom: 2,
                }}>
                  {option.label}
                </div>
                <div style={{
                  fontFamily: 'var(--kff-data-font)',
                  fontSize: 13,
                  color: 'var(--ion-color-medium)',
                }}>
                  {option.description}
                </div>
              </div>
              {isSelected && (
                <div style={{
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  background: 'var(--kff-forge-gold)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#0a1a2a',
                  fontSize: 14,
                  fontWeight: 700,
                }}>
                  ✓
                </div>
              )}
            </button>
          );
        })}
      </div>

      <div style={{
        marginTop: 20,
        padding: 12,
        background: 'var(--ion-color-step-100)',
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <span style={{
          fontFamily: 'var(--kff-data-font)',
          fontSize: 13,
          color: 'var(--ion-color-medium)',
        }}>
          Currently using:
        </span>
        <span style={{
          fontFamily: 'var(--kff-heading-font)',
          fontSize: 14,
          fontWeight: 600,
          color: 'var(--kff-forge-gold)',
          textTransform: 'capitalize',
        }}>
          {resolvedTheme} theme
          {themeMode === 'system' && (
            <span style={{
              fontWeight: 400,
              color: 'var(--ion-color-medium)',
              marginLeft: 4,
            }}>
              (auto)
            </span>
          )}
        </span>
      </div>
    </Card>
  );
};

export default AppearanceTab;
